module.exports = new __parcel__URL__("bg_stars_box_02.35e5f5a7.jpg").toString();